'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _TailSpin = require('./TailSpin');

var _TailSpin2 = _interopRequireDefault(_TailSpin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _TailSpin2.default;